import log from 'salvo-lite/log'

class Enable {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-enable'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const self = this
        setTimeout(function () {
            self.checkAll()
        }, 500)
    }

    success () {
        this._elem.disabled = false
        if (this._data.textChange) {
            this._elem.textContent = this._data.textChange
        }
        if (this._data.valueChange) {
            this._elem.value = this._data.valueChange
        }
    }

    checkAll () {
        if (this.checkRadios()) {
            this.success()
        }
    }

    checkRadios () {
        let allChecked = true
        for (let i = 0; i < this._data.radios.length; i++) {
            let checked = false
            const wrapperElem = document.querySelector(this._data.radios[i])
            const radios = wrapperElem.querySelectorAll('input[type="radio"]')
            for (let i = 0; i < radios.length; i++) {
                const radio = radios[i]
                if (radio.checked) {
                    checked = true
                }
                radio.addEventListener('click', () => {
                    this.checkAll()
                })
            }
            if (!checked) {
                allChecked = checked
            }
        }
        return allChecked
    }
}

export default Enable



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Enable.js